webpackJsonp([35783957827783],{

/***/ 508:
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(178);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(593);
	var each = __webpack_require__(288).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(591);
	var Util = __webpack_require__(288);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 593:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(592);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(992);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*jshint -W054 */
	(function (exports) {
	  'use strict';
	
	  // http://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
	  function shuffle(array) {
	    var currentIndex = array.length
	      , temporaryValue
	      , randomIndex
	      ;
	
	    // While there remain elements to shuffle...
	    while (0 !== currentIndex) {
	
	      // Pick a remaining element...
	      randomIndex = Math.floor(Math.random() * currentIndex);
	      currentIndex -= 1;
	
	      // And swap it with the current element.
	      temporaryValue = array[currentIndex];
	      array[currentIndex] = array[randomIndex];
	      array[randomIndex] = temporaryValue;
	    }
	
	    return array;
	  }
	
	  exports.knuthShuffle = shuffle;
	}('undefined' !== typeof exports && exports || 'undefined' !== typeof window && window || global));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(2),__webpack_require__(54)):"function"==typeof define&&define.amd?define(["react","prop-types","react-dom"],t):"object"==typeof exports?exports["react-parallax"]=t(require("react"),require("prop-types"),require("react-dom")):e["react-parallax"]=t(e.React,e.PropTypes,e.ReactDOM)}(this,function(e,t,n){return function(e){function t(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4)}([function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(1),u=i(l),c=n(0),d=i(c),h=function(e){function t(){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),s(t,[{key:"render",value:function(){return d.default.createElement("div",{className:"react-parallax-background "+this.props.className},this.props.children)}}],[{key:"isParallaxBackground",value:function(){return!0}}]),t}(d.default.Component);h.propTypes={children:u.default.node,className:u.default.string},h.defaultProps={className:""},t.default=h},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(1),u=i(l),c=n(0),d=i(c),h=n(6),f=i(h),p=n(5),g=function(e){function t(e){r(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={bgImage:e.bgImage,childStyle:{position:"relative"}},n.canUseDOM=(0,p.canUseDOM)(),n.ReactDOM=f.default.findDOMNode?f.default:d.default,n.node=null,n.content=null,n.splitChildren=(0,p.getSplitChildren)(e),n.bgImageLoaded=!1,n.parent=e.parent,n.parentHeight=(0,p.getNodeHeight)(n.canUseDOM,n.parent),n.timestamp=Date.now(),n.dynamicBlur=!(!e.blur||void 0===e.blur.min||void 0===e.blur.max),n.autobind(),n}return a(t,e),s(t,[{key:"componentDidMount",value:function(){var e=this.props.parent;this.parent=e||document,this.addListeners(this.props),this.node=this.ReactDOM.findDOMNode(this),this.state.bgImage?this.loadImage(this.state.bgImage):this.updatePosition(),this.setParallaxStyle(),this.setInitialBackgroundStyles(this.img),this.setInitialBackgroundStyles(this.bg)}},{key:"componentWillReceiveProps",value:function(e){this.splitChildren=(0,p.getSplitChildren)(e),e.parent&&this.parent!==e.parent&&(this.parent=e.parent,this.removeListeners(),this.addListeners()),this.parentHeight=(0,p.getNodeHeight)(this.canUseDOM,this.parent),this.state.bgImage!==e.bgImage&&this.loadImage(e.bgImage)}},{key:"shouldComponentUpdate",value:function(e,t){return e.bgImage===this.props.bgImage||t.bgImage!==this.state.bgImage}},{key:"componentWillUnmount",value:function(){this.removeListeners(this.parent)}},{key:"onWindowResize",value:function(){this.parentHeight=(0,p.getNodeHeight)(this.canUseDOM,this.parent),this.updatePosition()}},{key:"onWindowLoad",value:function(){this.updatePosition()}},{key:"onScroll",value:function(e){if(this.canUseDOM){var t=Date.now();t-this.timestamp>=10&&(window.requestAnimationFrame(this.updatePosition),this.timestamp=t)}}},{key:"setParallaxStyle",value:function(){this.node&&(this.node.style.position="relative",this.node.style.overflow="hidden")}},{key:"setInitialBackgroundStyles",value:function(e){var t=this;e&&(e.style.position="absolute",e.style.left="50%",e.style.WebkitTransform="translate3d(-50%, 0, 0)",e.style.transform="translate3d(-50%, 0, 0)",e.style.WebkitTransformStyle="preserve-3d",e.style.WebkitBackfaceVisibility="hidden",e.style.MozBackfaceVisibility="hidden",e.style.MsBackfaceVisibility="hidden",this.props.bgStyle&&Object.keys(this.props.bgStyle).forEach(function(n){e.style[n]=t.props.bgStyle[n]}))}},{key:"setBackgroundPosition",value:function(e){var t=this.props,n=t.disabled,i=t.strength;if(!0!==n){var r=i<0,o=(r?i:0)-i*e;this.bg.style.WebkitTransform="translate3d(-50%, "+o+"px, 0)",this.bg.style.transform="translate3d(-50%, "+o+"px, 0)"}}},{key:"setImagePosition",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.props,i=n.bgHeight,r=n.bgWidth,o=n.disabled,a=n.strength,s=n.blur,l=i||(t?"auto":this.getImageHeight()+"px"),u=r||(t?this.contentWidth+"px":"auto");if(this.img.style.height=l,this.img.style.width=u,!0!==o){var c=a<0,d=(c?a:0)-a*e;if(this.img.style.WebkitTransform="translate3d(-50%, "+d+"px, 0)",this.img.style.transform="translate3d(-50%, "+d+"px, 0)",s){var h=this.dynamicBlur?s.min+(1-e)*s.max:s;(0,p.setBlur)(this.img,h)}}}},{key:"getImageHeight",value:function(){var e=this.props.strength<0,t=e?2.5:1,n=t*Math.abs(this.props.strength);return Math.floor(this.contentHeight+n)}},{key:"addListeners",value:function(){this.canUseDOM&&this.parent&&(this.parent.addEventListener("scroll",this.onScroll,!1),window.addEventListener("resize",this.onWindowResize,!1),window.addEventListener("load",this.onWindowLoad,!1))}},{key:"removeListeners",value:function(){this.canUseDOM&&this.parent&&(this.parent.removeEventListener("scroll",this.onScroll,!1),window.removeEventListener("resize",this.onWindowResize,!1),window.removeEventListener("load",this.onWindowLoad,!1))}},{key:"loadImage",value:function(e){var t=this,n=new Image;n.onload=function(n){t.setState({bgImage:e},function(){return t.updatePosition()})},n.onerror=n.onload,n.src=e}},{key:"bgMounted",value:function(e){this.bg=this.ReactDOM.findDOMNode(e)}},{key:"updatePosition",value:function(){var e=!1;this.content=this.ReactDOM.findDOMNode(this.refs.content),this.contentHeight=this.content.getBoundingClientRect().height,this.contentWidth=this.node.getBoundingClientRect().width,this.img&&this.img.naturalWidth/this.img.naturalHeight<this.contentWidth/this.getImageHeight()&&(e=!0);var t=(0,p.getRelativePosition)(this.node,this.canUseDOM,this.parent);this.img&&this.setImagePosition(t,e),this.bg&&this.splitChildren.bgChildren.length>0&&this.setBackgroundPosition(t)}},{key:"autobind",value:function(){this.onScroll=this.onScroll.bind(this),this.onWindowResize=this.onWindowResize.bind(this),this.updatePosition=this.updatePosition.bind(this),this.onWindowLoad=this.onWindowLoad.bind(this)}},{key:"log",value:function(){if(this.props.log){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];console.log(t)}}},{key:"render",value:function(){var e=this;return d.default.createElement("div",{className:"react-parallax "+this.props.className,style:this.props.style},this.state.bgImage?d.default.createElement("img",{className:this.props.bgClassName,src:this.state.bgImage,ref:function(t){return e.img=t},alt:this.props.bgImageAlt}):null,this.splitChildren.bgChildren.length>0?d.default.createElement("div",{className:"react-parallax-background-children",ref:function(t){return e.bgMounted(t)}},this.splitChildren.bgChildren):null,d.default.createElement("div",{className:"react-parallax-content",style:this.state.childStyle,ref:"content"},this.splitChildren.children))}}]),t}(d.default.Component);g.propTypes={bgClassName:u.default.string,bgHeight:u.default.string,bgImage:u.default.string,bgImageAlt:u.default.string,bgStyle:u.default.object,bgWidth:u.default.string,blur:u.default.oneOfType([u.default.number,u.default.object]),className:u.default.string,disabled:u.default.bool,log:u.default.bool,parent:u.default.any,strength:u.default.number,style:u.default.object},g.defaultProps={bgClassName:"react-parallax-bgimage",bgImageAlt:"",className:"",disabled:!1,log:!1,strength:100},t.default=g},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Background=t.Parallax=void 0;var r=n(3),o=i(r),a=n(2),s=i(a);t.Parallax=o.default,t.Background=s.default},function(e,t,n){"use strict";function i(e,t){if(!t)return!1;var n=e.getBoundingClientRect().top,i=e.getBoundingClientRect().bottom;return n<=0&&i>=0||n>=0&&i<=window.innerHeight||n<=window.innerHeight&&i>=window.innerHeight}function r(e){if(!e)return 0;var t=window,n=document,i=n.documentElement,r=n.getElementsByTagName("body")[0];return t.innerHeight||i.clientHeight||r.clientHeight}function o(e,t){return e?t?t.clientHeight:r(e):0}function a(){return!("undefined"==typeof window||!window.document||!window.document.createElement)}function s(e,t,n){return(n-e)/(t-e)||0}function l(e,t,n){if(!t)return 0;var i=e,r=Math.round(i.getBoundingClientRect().top),a=o(t);return r=r>a?a:r,s(0,a,r)}function u(e){var t=[],n=h.default.Children.toArray(e.children);return n.forEach(function(e,i){e.type&&e.type.isParallaxBackground&&(t=t.concat(n.splice(i,1)))}),{bgChildren:t,children:n}}function c(e,t){e.style.WebkitFilter="blur("+t+"px)",e.style.filter="blur("+t+"px)"}Object.defineProperty(t,"__esModule",{value:!0}),t.isScrolledIntoView=i,t.getWindowHeight=r,t.getNodeHeight=o,t.canUseDOM=a,t.getPercentage=s,t.getRelativePosition=l,t.getSplitChildren=u,t.setBlur=c;var d=n(0),h=function(e){return e&&e.__esModule?e:{default:e}}(d)},function(e,t){e.exports=n}])});

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(214);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    // init: function hook that gets called right before InnerSlider mounts
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow should react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	exports.default = defaultProps;

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(888);

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(887);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(214);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(885);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(377);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(580);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(17);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(889);
	
	var _dots = __webpack_require__(883);
	
	var _arrows = __webpack_require__(882);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null, // wraps the track
	  track: null, // component that rolls out like a film
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    // number of slides shown in the active frame
	    var slidesToShow = this.props.slidesToShow;
	    var childrenLen = _react2.default.Children.count(this.props.children);
	    var currentSlide = this.state.currentSlide;
	    for (var i = 0; i < childrenLen; i++) {
	      // if currentSlide is the lastSlide of current frame and 
	      // rest of the active slides are on the left of currentSlide
	      // then the following might cause a problem
	      if (i >= currentSlide && i < currentSlide + slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	    if (this.props.centerMode === true) {
	      // add slides to show on the left in case of centerMode with lazyLoad
	      var additionalCount = Math.floor(slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) {
	        additionalCount += 1;
	      }
	      var additionalNum = currentSlide;
	      while (additionalCount--) {
	        lazyLoadedList.push((--additionalNum + childrenLen) % childrenLen);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.lazyLoad && this.props.centerMode) {
	      var childrenLen = _react2.default.Children.count(this.props.children);
	      var additionalCount = Math.floor(this.props.slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) additionalCount++;
	      var leftMostSlide = (this.state.currentSlide - additionalCount + childrenLen) % childrenLen;
	      var rightMostSlide = (this.state.currentSlide + additionalCount) % childrenLen;
	      if (!this.state.lazyLoadedList.includes(leftMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [leftMostSlide]
	        });
	      }
	      if (!this.state.lazyLoadedList.includes(rightMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [rightMostSlide]
	        });
	      }
	    }
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slideHeight: this.state.slideHeight,
	      listHeight: this.state.listHeight,
	      vertical: this.props.vertical,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging,
	        infinite: this.props.infinite
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(378);
	
	var _helpers = __webpack_require__(214);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(17);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(54);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  // gets called if slide is changed via arrows or dots but not swiping/dragging
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad && !this.props.infinite) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad && !this.props.infinite) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  // invoked when swiping/dragging starts (just once)
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  // continuous invokation while swiping/dragging is going on
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll); // this might not be correct, using getDotCount may be more accurate
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      if (!this.props.rtl) {
	        swipeLeft = curLeft + touchSwipeLength * positionOffset;
	      } else {
	        swipeLeft = curLeft - touchSwipeLength * positionOffset;
	      }
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var currentIndex = this.props.rtl === true ? this.state.slideCount - this.state.currentSlide : this.state.currentSlide;
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(54);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(378);
	
	var _objectAssign = __webpack_require__(17);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  // supposed to start autoplay of slides
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      if (props.centerPadding.slice(-1) === '%') {
	        centerPaddingAdj *= listWidth / 100;
	      }
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	      // this reference isn't lost due to mixin
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      if (props.centerPadding.slice(-1) === '%') {
	        centerPaddingAdj *= listWidth / 100;
	      }
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        var elem = slickList.querySelector(selector) || {};
	        slickList.style.height = (elem.offsetHeight || 0) + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // index is target slide index
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if infinite=false and target slide is out of range
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      if (targetLeft === currentLeft) {
	        targetSlide = currentSlide;
	      }
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var slidesToLoad = [];
	      var slideCount = this.state.slideCount;
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        if (this.state.lazyLoadedList.indexOf(i) < 0) {
	          slidesToLoad.push(i);
	        }
	        if (i >= slideCount && this.state.lazyLoadedList.indexOf(i - slideCount) < 0) {
	          slidesToLoad.push(i - slideCount);
	        }
	        if (i < 0 && this.state.lazyLoadedList.indexOf(i + slideCount) < 0) {
	          slidesToLoad.push(i + slideCount);
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	      callback = function callback() {
	        _this.setState(nextStateChanges, function () {
	          if (_this.props.afterChange) {
	            _this.props.afterChange(currentSlide);
	          }
	          delete _this.animationEndCallback;
	        });
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return 'left';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return 'right';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	exports.getPreClones = getPreClones;
	exports.getPostClones = getPostClones;
	exports.getTotalSlides = getTotalSlides;
	
	var _reactDom = __webpack_require__(54);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(17);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// checks if spec is the superset of keys in keysArray, i.e., spec contains all the keys from keysArray
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow; // this should probably be getTotalSlides
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	    trackWidth += spec.slideWidth / 2; // this is a temporary hack so that track div doesn't create new row for slight overflow
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	  if (spec.fade) {
	    style = {
	      opacity: 1
	    };
	  }
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	// gets total length of track that's on the left side of current slide
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var lastSlide = _reactDom2.default.findDOMNode(trackRef).children[slideCount - 1];
	    var max = -lastSlide.offsetLeft + listWidth - lastSlide.offsetWidth;
	    if (slideCount <= slidesToShow || infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[slideIndex];
	    } else {
	      targetSlideIndex = slideIndex + slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      if (infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex + slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	    if (spec.infinite === false && targetLeft < max) {
	      targetLeft = max;
	    }
	  }
	
	  return targetLeft;
	};
	
	function getPreClones(spec) {
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	}
	
	function getPostClones(spec) {
	  return spec.slideCount;
	}
	
	function getTotalSlides(spec) {
	  if (spec.slideCount === 1) {
	    return 1;
	  }
	  return getPreClones(spec) + spec.slideCount + getPostClones(spec);
	}

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(886);
	
	var _objectAssign = __webpack_require__(17);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(635);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(377);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(508);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(594);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        // when not using server side rendering
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.slickPause = function slickPause() {
	    this.innerSlider.pause();
	  };
	
	  Slider.prototype.slickPlay = function slickPlay() {
	    this.innerSlider.autoPlay();
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      // never executes in the first render
	      // so defaultProps should be already there in this.props
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 in centerMode, you are using ' + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== 'production') {
	        console.warn('slidesToShow should be equal to 1 when fade is true, you\'re using ' + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 when fade is true, you\'re using ' + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === 'string') {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(17);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  // if spec has currentSlideIndex, we can also apply slickCurrent class according to that (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2300-L2302)
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    // if we're going right to left, index is reversed
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    // index of the slide
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0; // concern: not sure if this should be correct (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2328-L2346)
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    // concern: following can be incorrect in case where currentSlide is lastSlide in frame and rest of the slides to show have index smaller than currentSlideIndex
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned,
	    'slick-current': slickCurrent // dubious in case of RTL
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    if (spec.vertical) {
	      style.top = -spec.index * spec.slideHeight;
	    } else {
	      style.left = -spec.index * spec.slideWidth;
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.visibility = spec.currentSlide === spec.index ? 'visible' : 'hidden';
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase + ', ' + 'visibility ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase + ', ' + 'visibility ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= spec.slidesToShow + (spec.centerMode ? 1 : 0) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    // var slides = renderSlides.call(this, this.props);
	    var slides = renderSlides(this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/frameblender.e7787e5d.png";

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/loveunique.d2104f4a.png";

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tylerlindsey.85c0045d.jpg";

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-light.ddb86a2f.svg";

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost14.fdd3ca69.jpg";

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost25.4ff50a36.jpg";

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost28.cecd8f09.jpg";

/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost3.61ef061e.jpg";

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost35.2e4f8c5c.jpg";

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost37.1f552923.jpg";

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost44.5454d3a7.jpg";

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost52.a096c704.jpg";

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost53.8138c54e.jpg";

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost54.f22c85a9.jpg";

/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost64.22c4eedd.jpg";

/***/ }),

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost77.a695f418.jpg";

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost78.ae09fb85.jpg";

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mpost79.43ada046.jpg";

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Zoom = __webpack_require__(76);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	var _semanticUiReact = __webpack_require__(15);
	
	var _BasicContainer = __webpack_require__(44);
	
	var _BasicContainer2 = _interopRequireDefault(_BasicContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var uuidv4 = __webpack_require__(43);
	var clients = [{ src: __webpack_require__(246), url: 'http://www.frameblenderfilms.com/' }, { src: __webpack_require__(247), url: 'http://loveuniquestudios.com/' }, { src: __webpack_require__(248), url: 'https://www.tylerandlindsey.com/' }];
	var clientText = 'AND MANY MORE. We respect the confidentiality of information of our clients, and will never disclose their information without permission.';
	
	var Clients = function (_Component) {
	  _inherits(Clients, _Component);
	
	  function Clients() {
	    _classCallCheck(this, Clients);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Clients.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _BasicContainer2.default,
	        null,
	        _react2.default.createElement(
	          _Zoom2.default,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Responsive,
	            { minWidth: _semanticUiReact.Responsive.onlyTablet.minWidth },
	            _react2.default.createElement(_semanticUiReact.Header, { content: 'Our Clients', className: 'mpost-header--huge', textAlign: 'center' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Responsive,
	            _semanticUiReact.Responsive.onlyMobile,
	            _react2.default.createElement(_semanticUiReact.Header, { content: 'Our Clients', className: 'mpost-header--huge mobile', textAlign: 'center' })
	          ),
	          _react2.default.createElement('div', { className: 'mpost-header--divider' }),
	          _react2.default.createElement(
	            _semanticUiReact.Container,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { centered: true, style: { maxWidth: '800px', margin: '0 auto' } },
	              clients.map(function (client) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { verticalAlign: 'middle', mobile: 16, computer: 4, largeScreen: 4, key: uuidv4() },
	                  _react2.default.createElement(_semanticUiReact.Image, { src: client.src, as: 'a', href: client.url, centered: true, size: 'large', className: 'mpost-client-logo' })
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Responsive,
	                { minWidth: _semanticUiReact.Responsive.onlyTablet.minWidth },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'mpost-p', style: { marginTop: '2rem', textAlign: 'center' } },
	                  clientText
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Responsive,
	                _semanticUiReact.Responsive.onlyMobile,
	                _react2.default.createElement(
	                  'p',
	                  { className: 'mpost-p mobile', style: { marginTop: '2rem', textAlign: 'center' } },
	                  clientText
	                )
	              ),
	              this.props.testimony && _react2.default.createElement(_semanticUiReact.Button, { as: _gatsbyLink2.default, to: 'testimonies/', content: 'Testimonies', className: 'mpost-button' })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Clients;
	}(_react.Component);
	
	exports.default = Clients;
	module.exports = exports['default'];

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeDesktopHeader = function (_Component) {
	    _inherits(HomeDesktopHeader, _Component);
	
	    function HomeDesktopHeader(props) {
	        _classCallCheck(this, HomeDesktopHeader);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.handleItemClick = function (e, _ref) {
	            var name = _ref.name;
	            return _this.setState({ activeItem: name });
	        };
	
	        _this.state = {
	            activeItem: 'home'
	        };
	        return _this;
	    }
	
	    HomeDesktopHeader.prototype.componentDidMount = function componentDidMount() {};
	
	    HomeDesktopHeader.prototype.render = function render() {
	        var activeItem = this.state.activeItem;
	
	        return _react2.default.createElement(
	            _semanticUiReact.Container,
	            { className: 'mpost-header--home--menu' },
	            _react2.default.createElement(
	                _semanticUiReact.Menu,
	                { style: { margin: '0 auto' }, compact: true, secondary: true, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Menu.Menu,
	                    { position: 'left' },
	                    _react2.default.createElement(_semanticUiReact.Menu.Item, { as: _gatsbyLink2.default, className: 'mpost-header--home--menu-item', to: '/', name: 'HOME', active: activeItem === 'HOME', onClick: this.handleItemClick }),
	                    _react2.default.createElement(_semanticUiReact.Menu.Item, { as: _gatsbyLink2.default, className: 'mpost-header--home--menu-item', to: 'work/', name: 'WORK', active: activeItem === 'WORK', onClick: this.handleItemClick })
	                ),
	                _react2.default.createElement(_semanticUiReact.Image, { centered: true, className: 'mpost-header--logo--light', src: __webpack_require__(474), size: 'medium' }),
	                _react2.default.createElement(
	                    _semanticUiReact.Menu.Menu,
	                    { position: 'right' },
	                    _react2.default.createElement(_semanticUiReact.Menu.Item, { as: _gatsbyLink2.default, className: 'mpost-header--home--menu-item', to: 'services/', name: 'SERVICES', active: activeItem === 'SERVICES', onClick: this.handleItemClick }),
	                    _react2.default.createElement(_semanticUiReact.Menu.Item, { as: _gatsbyLink2.default, className: 'mpost-header--home--menu-item', to: 'contact/', name: 'CONTACT', active: activeItem === 'CONTACT', onClick: this.handleItemClick })
	                )
	            )
	        );
	    };
	
	    return HomeDesktopHeader;
	}(_react.Component);
	
	exports.default = HomeDesktopHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileDesktopHeader = function (_Component) {
	    _inherits(MobileDesktopHeader, _Component);
	
	    function MobileDesktopHeader(props) {
	        _classCallCheck(this, MobileDesktopHeader);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.handleItemClick = function (e, _ref) {
	            var name = _ref.name;
	            return _this.setState({ activeItem: name });
	        };
	
	        _this.handleMenuOpen = function () {
	            var state = !_this.state.menuOpen;
	            _this.setState({ menuOpen: state });
	            _this.props.menuOpen(state);
	        };
	
	        _this.state = {
	            activeItem: 'home'
	        };
	        return _this;
	    }
	
	    MobileDesktopHeader.prototype.render = function render() {
	        var _state = this.state,
	            activeItem = _state.activeItem,
	            menuOpen = _state.menuOpen;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _semanticUiReact.Container,
	                { className: 'mpost-header--home--menu mobile' },
	                _react2.default.createElement(_semanticUiReact.Image, { centered: true, className: 'mpost-header--logo--light', src: __webpack_require__(474), size: 'mini' }),
	                _react2.default.createElement(_semanticUiReact.Button, { className: 'mpost-mobile-button--menu', basic: true, inverted: true, icon: 'sidebar', onClick: this.props.menuOpen })
	            )
	        );
	    };
	
	    return MobileDesktopHeader;
	}(_react.Component);
	
	exports.default = MobileDesktopHeader;
	
	
	MobileDesktopHeader.propTypes = {
	    menuOpen: _propTypes2.default.func
	};
	module.exports = exports['default'];

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvertedContainer = function (_Component) {
	    _inherits(InvertedContainer, _Component);
	
	    function InvertedContainer(props) {
	        _classCallCheck(this, InvertedContainer);
	
	        return _possibleConstructorReturn(this, _Component.call(this, props));
	    }
	
	    InvertedContainer.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _semanticUiReact.Responsive,
	                { minWidth: _semanticUiReact.Responsive.onlyTablet.minWidth },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mpost-section--inverted' },
	                    _react2.default.createElement(
	                        _semanticUiReact.Container,
	                        { textAlign: this.props.textAlign, className: 'mpost-section' },
	                        this.props.children
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _semanticUiReact.Responsive,
	                _semanticUiReact.Responsive.onlyMobile,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mpost-section--inverted' },
	                    _react2.default.createElement(
	                        _semanticUiReact.Container,
	                        { textAlign: this.props.textAlign, className: 'mpost-section mobile' },
	                        this.props.children
	                    )
	                )
	            )
	        );
	    };
	
	    return InvertedContainer;
	}(_react.Component);
	
	exports.default = InvertedContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fade = __webpack_require__(98);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _semanticUiReact = __webpack_require__(15);
	
	var _playButton = __webpack_require__(250);
	
	var _playButton2 = _interopRequireDefault(_playButton);
	
	var _mpost = __webpack_require__(256);
	
	var _mpost2 = _interopRequireDefault(_mpost);
	
	var _mpost3 = __webpack_require__(257);
	
	var _mpost4 = _interopRequireDefault(_mpost3);
	
	var _mpost5 = __webpack_require__(258);
	
	var _mpost6 = _interopRequireDefault(_mpost5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import img1 from '../assets/img/slideshow/mpost53.jpg'
	// import img2 from '../assets/img/slideshow/mpost14.jpg'
	// import img3 from '../assets/img/slideshow/mpost25.jpg'
	// import img4 from '../assets/img/slideshow/mpost3.jpg'
	// import img5 from '../assets/img/slideshow/mpost35.jpg'
	// import img6 from '../assets/img/slideshow/mpost37.jpg'
	// import img7 from '../assets/img/slideshow/mpost44.jpg'
	// import img8 from '../assets/img/slideshow/mpost52.jpg'
	// import img9 from '../assets/img/slideshow/mpost28.jpg'
	// import img10 from '../assets/img/slideshow/mpost64.jpg'
	// import img11 from '../assets/img/slideshow/mpost77.jpg'
	var uuidv4 = __webpack_require__(43);
	var featured = [{
	    title: 'Frameblender \n Films',
	    sub: 'Audsley and Tucker',
	    text: 'Versatility is something you can acquire through practice, but vulnerability is a gift! This is the heart of every Frameblender Films wedding narrative. Their solid brand for emotional and immersive storytelling takes us deeper in our journey in expressing heartfelt wedding moments beyond the surface.',
	    image: _mpost4.default,
	    video: 'https://player.vimeo.com/video/255090148',
	    facebook: 'https://www.facebook.com/frameblenderfilms/',
	    instagram: 'https://www.instagram.com/frameblenderfilms/',
	    web: 'http://www.frameblenderfilms.com/'
	}, {
	    title: 'Tyler and Lindsey',
	    sub: 'Mackenzie and Scott',
	    text: 'Tyler and Lindsey’s hunger for perfection drives them to explore new things, and rediscover new strengths as they grow together in their passion for wedding cinematography. This young power couple from Texas believes their craft is not just about them doing what they love. It is – most importantly – about the couple sharing their lives.',
	    image: _mpost6.default,
	    video: 'https://player.vimeo.com/video/244450882',
	    facebook: 'https://www.facebook.com/TylerLovesLindsey/',
	    instagram: 'https://www.instagram.com/tylerandlindsey',
	    web: 'https://www.tylerandlindsey.com/'
	}, {
	    title: 'Mayad \n Studios',
	    sub: 'Pao and Cherry',
	    text: 'Our company ventured into the wedding industry 11 years ago. After eleven years, our primary aim remains the same- to deliver timeless and elegant wedding photos and films that become constant reminders of the bonds of true love and lasting commitment.',
	    image: _mpost2.default,
	    video: 'https://player.vimeo.com/video/208095882',
	    facebook: 'https://www.facebook.com/mayadstudios/',
	    instagram: 'https://www.instagram.com/mayadstudios/?hl=en',
	    web: 'http://www.mayadstudios.com/'
	}];
	
	var Works = function (_Component) {
	    _inherits(Works, _Component);
	
	    function Works() {
	        _classCallCheck(this, Works);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Works.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _semanticUiReact.Responsive,
	                { minWidth: _semanticUiReact.Responsive.onlyTablet.minWidth },
	                _react2.default.createElement(_semanticUiReact.Divider, { style: { marginTop: 0, height: '0px', backgroundColor: 'transparent', border: 0 }, clearing: true }),
	                _react2.default.createElement(
	                    _semanticUiReact.Container,
	                    { fluid: true },
	                    _react2.default.createElement(
	                        _semanticUiReact.Grid,
	                        { verticalAlign: 'middle' },
	                        Object.keys(featured).map(function (key) {
	                            // Odd, even checker
	                            if (parseInt(key) % 2 === 0) {
	                                return _react2.default.createElement(
	                                    _semanticUiReact.Grid.Row,
	                                    { stretched: true, key: uuidv4(), className: 'mpost-featured--row' },
	                                    _react2.default.createElement(
	                                        _semanticUiReact.Grid.Column,
	                                        { mobile: 16, computer: 10, largeScreen: 10, className: 'mpost-featured-image', style: { backgroundImage: 'url(' + featured[key].image + ')' } },
	                                        _react2.default.createElement(
	                                            _semanticUiReact.Modal,
	                                            { closeIcon: true, basic: true, dimmer: 'blurring', size: 'fullscreen', trigger: _react2.default.createElement(
	                                                    _semanticUiReact.Button,
	                                                    { size: 'massive', fluid: true, inverted: true, basic: true, className: 'mpost-video--button' },
	                                                    _react2.default.createElement(_semanticUiReact.Image, { centered: true, src: _playButton2.default })
	                                                ) },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'embed-container' },
	                                                _react2.default.createElement('iframe', { src: featured[key].video, frameborder: '0', webkitAllowFullScreen: true, mozallowfullscreen: true, allowFullScreen: true })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _semanticUiReact.Grid.Column,
	                                        { mobile: 16, computer: 6, largeScreen: 6 },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'mpost-featured-contents' },
	                                            _react2.default.createElement(
	                                                _Fade2.default,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _semanticUiReact.Header,
	                                                    { as: 'h1', className: 'mpost-header--big' },
	                                                    featured[key].title.split('\n').map(function (item, key) {
	                                                        return _react2.default.createElement(
	                                                            'span',
	                                                            { key: key },
	                                                            item,
	                                                            _react2.default.createElement('br', null)
	                                                        );
	                                                    })
	                                                ),
	                                                _react2.default.createElement(_semanticUiReact.Header, { as: 'h2', content: featured[key].sub, className: 'mpost-subheader--gradient' }),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    { className: 'mpost-p' },
	                                                    featured[key].text
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    { className: 'mpost-p' },
	                                                    _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, icon: 'facebook', href: featured[key].facebook, size: 'huge', className: 'mpost-featured--social', target: '_blank' }),
	                                                    _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, icon: 'instagram', href: featured[key].instagram, size: 'huge', className: 'mpost-featured--social', target: '_blank' }),
	                                                    _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, icon: 'linkify', href: featured[key].web, size: 'huge', className: 'mpost-featured--social', target: '_blank' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                );
	                            } else {
	                                var _React$createElement, _React$createElement2, _React$createElement3;
	
	                                return _react2.default.createElement(
	                                    _semanticUiReact.Grid.Row,
	                                    { stretched: true, key: uuidv4(), className: 'mpost-featured--row inverted' },
	                                    _react2.default.createElement(
	                                        _semanticUiReact.Grid.Column,
	                                        { mobile: 16, computer: 6, largeScreen: 6 },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'mpost-featured-contents' },
	                                            _react2.default.createElement(
	                                                _Fade2.default,
	                                                null,
	                                                _react2.default.createElement(
	                                                    _semanticUiReact.Header,
	                                                    { as: 'h1', textAlign: 'right', style: { color: "#FFF" }, inverted: true, className: 'mpost-header--big' },
	                                                    featured[key].title.split('\n').map(function (item, key) {
	                                                        return _react2.default.createElement(
	                                                            'span',
	                                                            { key: key },
	                                                            item,
	                                                            _react2.default.createElement('br', null)
	                                                        );
	                                                    })
	                                                ),
	                                                _react2.default.createElement(_semanticUiReact.Header, { as: 'h2', textAlign: 'right', inverted: true, content: featured[key].sub, className: 'mpost-subheader--gradient' }),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    { className: 'mpost-p inverted right' },
	                                                    featured[key].text
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    { className: 'mpost-p right' },
	                                                    _react2.default.createElement(_semanticUiReact.Button, (_React$createElement = { basic: true, inverted: true, circular: true, href: featured[key].facebook }, _React$createElement['inverted'] = true, _React$createElement.icon = 'facebook', _React$createElement.size = 'huge', _React$createElement.className = 'mpost-featured--social secondary', _React$createElement.target = '_blank', _React$createElement)),
	                                                    _react2.default.createElement(_semanticUiReact.Button, (_React$createElement2 = { basic: true, inverted: true, circular: true, href: featured[key].instagram }, _React$createElement2['inverted'] = true, _React$createElement2.icon = 'instagram', _React$createElement2.size = 'huge', _React$createElement2.className = 'mpost-featured--social secondary', _React$createElement2.target = '_blank', _React$createElement2)),
	                                                    _react2.default.createElement(_semanticUiReact.Button, (_React$createElement3 = { basic: true, inverted: true, circular: true, href: featured[key].web }, _React$createElement3['inverted'] = true, _React$createElement3.icon = 'linkify', _React$createElement3.size = 'huge', _React$createElement3.className = 'mpost-featured--social secondary', _React$createElement3.target = '_blank', _React$createElement3))
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _semanticUiReact.Grid.Column,
	                                        { mobile: 16, computer: 10, largeScreen: 10, className: 'mpost-featured-image', style: { backgroundImage: 'url(' + featured[key].image + ')' } },
	                                        _react2.default.createElement(
	                                            _semanticUiReact.Modal,
	                                            { closeIcon: true, basic: true, dimmer: 'blurring', size: 'fullscreen', trigger: _react2.default.createElement(
	                                                    _semanticUiReact.Button,
	                                                    { size: 'massive', fluid: true, inverted: true, basic: true, className: 'mpost-video--button' },
	                                                    _react2.default.createElement(_semanticUiReact.Image, { centered: true, src: _playButton2.default })
	                                                ) },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'embed-container' },
	                                                _react2.default.createElement('iframe', { src: featured[key].video, frameborder: '0', webkitAllowFullScreen: true, mozallowfullscreen: true, allowFullScreen: true })
	                                            )
	                                        )
	                                    )
	                                );
	                            }
	                        })
	                    )
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, { style: { marginTop: 0, height: '0px', backgroundColor: 'transparent', border: 0 }, clearing: true })
	            ),
	            _react2.default.createElement(
	                _semanticUiReact.Responsive,
	                _semanticUiReact.Responsive.onlyMobile,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    Object.keys(featured).map(function (key) {
	                        // Odd, even checker
	                        if (parseInt(key) % 2 === 0) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: uuidv4() },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'mpost-featured-image mobile', style: { backgroundImage: 'url(' + featured[key].image + ')' } },
	                                    _react2.default.createElement(
	                                        _semanticUiReact.Modal,
	                                        { closeIcon: true, basic: true, dimmer: 'blurring', size: 'fullscreen', trigger: _react2.default.createElement(
	                                                _semanticUiReact.Button,
	                                                { size: 'massive', fluid: true, inverted: true, basic: true, className: 'mpost-video--button mobile' },
	                                                _react2.default.createElement(_semanticUiReact.Image, { centered: true, src: _playButton2.default })
	                                            ) },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'embed-container' },
	                                            _react2.default.createElement('iframe', { src: featured[key].video, frameborder: '0', webkitAllowFullScreen: true, mozallowfullscreen: true, allowFullScreen: true })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'mpost-featured-contents mobile' },
	                                    _react2.default.createElement(
	                                        _Fade2.default,
	                                        null,
	                                        _react2.default.createElement(
	                                            _semanticUiReact.Header,
	                                            { as: 'h1', textAlign: 'center', className: 'mpost-header--big mobile' },
	                                            featured[key].title.split('\n').map(function (item, key) {
	                                                return _react2.default.createElement(
	                                                    'span',
	                                                    { key: key },
	                                                    item,
	                                                    _react2.default.createElement('br', null)
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(_semanticUiReact.Header, { textAlign: 'center', as: 'h3', content: featured[key].sub, className: 'mpost-subheader--gradient' }),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'mpost-p mobile' },
	                                            featured[key].text
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'mpost-p mobile', style: { textAlign: 'center' } },
	                                            _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, icon: 'facebook', href: featured[key].facebook, size: 'huge', className: 'mpost-featured--social', target: '_blank' }),
	                                            _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, icon: 'instagram', href: featured[key].instagram, size: 'huge', className: 'mpost-featured--social', target: '_blank' }),
	                                            _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, icon: 'linkify', href: featured[key].web, size: 'huge', className: 'mpost-featured--social', target: '_blank' })
	                                        )
	                                    )
	                                )
	                            );
	                        } else {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: uuidv4(), className: 'mpost-featured--row inverted' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'mpost-featured-image mobile', style: { backgroundImage: 'url(' + featured[key].image + ')' } },
	                                    _react2.default.createElement(
	                                        _semanticUiReact.Modal,
	                                        { closeIcon: true, basic: true, dimmer: 'blurring', size: 'fullscreen', trigger: _react2.default.createElement(
	                                                _semanticUiReact.Button,
	                                                { size: 'massive', fluid: true, inverted: true, basic: true, className: 'mpost-video--button mobile' },
	                                                _react2.default.createElement(_semanticUiReact.Image, { centered: true, src: _playButton2.default })
	                                            ) },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'embed-container' },
	                                            _react2.default.createElement('iframe', { src: featured[key].video, frameborder: '0', webkitAllowFullScreen: true, mozallowfullscreen: true, allowFullScreen: true })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'mpost-featured-contents mobile' },
	                                    _react2.default.createElement(
	                                        _Fade2.default,
	                                        null,
	                                        _react2.default.createElement(
	                                            _semanticUiReact.Header,
	                                            { as: 'h1', style: { color: '#FFF' }, textAlign: 'center', inverted: true, className: 'mpost-header--big mobile' },
	                                            featured[key].title.split('\n').map(function (item, key) {
	                                                return _react2.default.createElement(
	                                                    'span',
	                                                    { key: key },
	                                                    item,
	                                                    _react2.default.createElement('br', null)
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(_semanticUiReact.Header, { textAlign: 'center', as: 'h3', inverted: true, content: featured[key].sub, className: 'mpost-subheader--gradient' }),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'mpost-p inverted mobile' },
	                                            featured[key].text
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'mpost-p mobile', style: { textAlign: 'center' } },
	                                            _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, inverted: true, icon: 'facebook', href: featured[key].facebook, size: 'huge', className: 'mpost-featured--social', target: '_blank' }),
	                                            _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, inverted: true, icon: 'instagram', href: featured[key].instagram, size: 'huge', className: 'mpost-featured--social', target: '_blank' }),
	                                            _react2.default.createElement(_semanticUiReact.Button, { basic: true, circular: true, inverted: true, icon: 'linkify', href: featured[key].web, size: 'huge', className: 'mpost-featured--social', target: '_blank' })
	                                        )
	                                    )
	                                )
	                            );
	                        }
	                    })
	                )
	            )
	        );
	    };
	
	    return Works;
	}(_react.Component);
	
	exports.default = Works;
	module.exports = exports['default'];

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactParallax = __webpack_require__(836);
	
	var _Zoom = __webpack_require__(76);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	var _reactSlick = __webpack_require__(884);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _semanticUiReact = __webpack_require__(15);
	
	var _MobileSubpageSideBar = __webpack_require__(81);
	
	var _MobileSubpageSideBar2 = _interopRequireDefault(_MobileSubpageSideBar);
	
	var _mpost = __webpack_require__(995);
	
	var _mpost2 = _interopRequireDefault(_mpost);
	
	var _mpost3 = __webpack_require__(996);
	
	var _mpost4 = _interopRequireDefault(_mpost3);
	
	var _mpost5 = __webpack_require__(251);
	
	var _mpost6 = _interopRequireDefault(_mpost5);
	
	var _mpost7 = __webpack_require__(997);
	
	var _mpost8 = _interopRequireDefault(_mpost7);
	
	var _mpost9 = __webpack_require__(998);
	
	var _mpost10 = _interopRequireDefault(_mpost9);
	
	var _mpost11 = __webpack_require__(252);
	
	var _mpost12 = _interopRequireDefault(_mpost11);
	
	var _mpost13 = __webpack_require__(253);
	
	var _mpost14 = _interopRequireDefault(_mpost13);
	
	var _mpost15 = __webpack_require__(254);
	
	var _mpost16 = _interopRequireDefault(_mpost15);
	
	var _mpost17 = __webpack_require__(255);
	
	var _mpost18 = _interopRequireDefault(_mpost17);
	
	var _mpost19 = __webpack_require__(999);
	
	var _mpost20 = _interopRequireDefault(_mpost19);
	
	var _mpost21 = __webpack_require__(1000);
	
	var _mpost22 = _interopRequireDefault(_mpost21);
	
	var _BasicContainer = __webpack_require__(44);
	
	var _BasicContainer2 = _interopRequireDefault(_BasicContainer);
	
	var _Clients = __webpack_require__(157);
	
	var _Clients2 = _interopRequireDefault(_Clients);
	
	var _ContactSection = __webpack_require__(101);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _Footer = __webpack_require__(80);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _GradientContainer = __webpack_require__(102);
	
	var _GradientContainer2 = _interopRequireDefault(_GradientContainer);
	
	var _HomeDesktopHeader = __webpack_require__(485);
	
	var _HomeDesktopHeader2 = _interopRequireDefault(_HomeDesktopHeader);
	
	var _HomeMobileHeader = __webpack_require__(486);
	
	var _HomeMobileHeader2 = _interopRequireDefault(_HomeMobileHeader);
	
	var _InvertedContainer = __webpack_require__(487);
	
	var _InvertedContainer2 = _interopRequireDefault(_InvertedContainer);
	
	var _Works = __webpack_require__(158);
	
	var _Works2 = _interopRequireDefault(_Works);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Slideshow
	// import IMAGE1 from '../assets/img/1.jpeg'
	// import IMAGE2 from '../assets/img/2.jpeg'
	// import IMAGE3 from '../assets/img/3.jpeg'
	var shuffle = __webpack_require__(636).knuthShuffle;
	var slideshow = {
	  dots: false,
	  infinite: true,
	  speed: 5000,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  autoplay: true,
	  fade: true,
	  draggable: true,
	  autoplaySpeed: 10000,
	  swipe: true
	};
	
	var images = [_mpost18.default, _mpost2.default, _mpost4.default, _mpost8.default, _mpost10.default, _mpost12.default, _mpost14.default, _mpost16.default, _mpost6.default, _mpost20.default, _mpost22.default];
	var uuidv4 = __webpack_require__(43);
	var services = ['Documentaries', 'Wedding Films', 'Highlight Films', 'Trailer', 'Photo Coloring and Layout'];
	
	// const clients = [
	//   'https://cdn.svgporn.com/logos/admob.svg',
	//   'https://cdn.svgporn.com/logos/akka.svg',
	//   'https://cdn.svgporn.com/logos/processwire.svg',
	//   'https://cdn.svgporn.com/logos/packer.svg',
	//   'https://cdn.svgporn.com/logos/fabric_io.svg',
	//   'https://cdn.svgporn.com/logos/dropbox.svg',
	//   'https://cdn.svgporn.com/logos/drift.svg',
	//   'https://cdn.svgporn.com/logos/glint.svg',
	//   'https://cdn.svgporn.com/logos/google-adsense.svg',
	//   'https://cdn.svgporn.com/logos/google-analytics.svg',
	//   'https://cdn.svgporn.com/logos/ibm.svg',
	//   'https://cdn.svgporn.com/logos/launchrock.svg',
	//   'https://cdn.svgporn.com/logos/udemy.svg',
	//   'https://cdn.svgporn.com/logos/woocommerce.svg',
	//   'https://cdn.svgporn.com/logos/aurous.svg',
	//   'https://cdn.svgporn.com/logos/instagram.svg'
	// ]
	
	var randomHeaderText = [{
	  detail: 'Welcome to Mayad Post-Production House, your trusted co-author and editor in imagining and crafting a classic memento that will last for a lifetime - a wedding film that shares the anthology of your love to the world.',
	  title: 'Imagining and Crafting a Classic Memento'
	}, {
	  detail: 'We help wedding filmmakers from around the world manage their post-production needs.',
	  title: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      'Welcome to'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'span',
	      null,
	      'MPOST'
	    )
	  )
	}];
	
	var subheaderText = ['We – the Mayad Post-Production House (MPOST) – are the secret powerhouse of the internationally-recognized Mayad Studios. We are a force of globally-competitive creative champions. And as a recognized authority in the art of editing cinematic wedding films, MPOST renders expertly post-production services internationally – from neighboring countries and across different continents.', 'Allow us to take an active part in your creative adventure. Allow us to be the secret of your success, and together, we will make the epic happen… the Mayad way.'];
	
	var serviceText = ['We give filmmakers the gift of time to grow their craft and business through our post-production services.', 'As post-production artists, we help our clients produce more films - giving them the luxury of making and nourishing lasting relationships to their expanding clientele.'];
	
	var featuredText = ['Your wedding film is not just a masterpiece from us. It’s the symbol of a wonderful collaboration between you and us – your romantic memoir and our gift in cinematic storytelling and editing. This is the reason why we call this piece of art ours.'];
	
	var HeaderSliderItem = function (_Component) {
	  _inherits(HeaderSliderItem, _Component);
	
	  function HeaderSliderItem(props) {
	    _classCallCheck(this, HeaderSliderItem);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  HeaderSliderItem.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Responsive,
	        { minWidth: _semanticUiReact.Responsive.onlyTablet.minWidth },
	        _react2.default.createElement(
	          _semanticUiReact.Container,
	          { fluid: true, className: 'mpost-header--home' },
	          _react2.default.createElement(
	            _reactParallax.Parallax,
	            {
	              bgImage: this.props.src,
	              bgImageAlt: '',
	              strength: 300,
	              bgClassName: 'mpost-header--home'
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'backround-overlay--dim' },
	              _react2.default.createElement('div', { className: 'mpost-header-spacer' }),
	              _react2.default.createElement(
	                _semanticUiReact.Container,
	                { className: 'mpost-identity' },
	                _react2.default.createElement(_semanticUiReact.Header, { className: 'mpost-header--jumbo', content: this.props.headerTitleText, inverted: true }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'mpost-header--text' },
	                  this.props.headerText
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Responsive,
	        _semanticUiReact.Responsive.onlyMobile,
	        _react2.default.createElement(
	          _semanticUiReact.Container,
	          { fluid: true, className: 'mpost-header--home mobile' },
	          _react2.default.createElement(
	            _reactParallax.Parallax,
	            {
	              bgImage: this.props.src,
	              bgImageAlt: '',
	              strength: 300,
	              bgClassName: 'mpost-header--home'
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'backround-overlay--dim' },
	              _react2.default.createElement('div', { className: 'mpost-header-spacer mobile' }),
	              _react2.default.createElement(
	                _semanticUiReact.Container,
	                { className: 'mpost-identity' },
	                _react2.default.createElement(_semanticUiReact.Header, { className: 'mpost-header--jumbo mobile', content: this.props.headerTitleText, inverted: true }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'mpost-header--text mobile' },
	                  this.props.headerText
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return HeaderSliderItem;
	}(_react.Component);
	
	var HomeContent = function (_Component2) {
	  _inherits(HomeContent, _Component2);
	
	  function HomeContent(props) {
	    _classCallCheck(this, HomeContent);
	
	    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));
	
	    _this2.openMenu = function (state) {
	      _this2.setState({ visible: state });
	      console.log(state);
	    };
	
	    _this2.state = {
	      visible: false
	    };
	    return _this2;
	  }
	
	  HomeContent.prototype.componentDidMount = function componentDidMount() {
	    setTimeout(function () {
	      window.dispatchEvent(new Event('resize'));
	    }, 1000);
	  };
	
	  HomeContent.prototype.render = function render() {
	    var visible = this.state.visible;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _MobileSubpageSideBar2.default,
	        { menuOpen: this.openMenu, visible: visible },
	        _react2.default.createElement(
	          _semanticUiReact.Responsive,
	          { minWidth: _semanticUiReact.Responsive.onlyTablet.minWidth },
	          _react2.default.createElement(_HomeDesktopHeader2.default, null),
	          _react2.default.createElement(
	            _reactSlick2.default,
	            slideshow,
	            Object.keys(images).map(function (i) {
	              var text = shuffle(randomHeaderText)[0];
	              // console.log(text)
	              return _react2.default.createElement(
	                'div',
	                { key: uuidv4() },
	                _react2.default.createElement(HeaderSliderItem, { src: images[i], headerText: text.detail, headerTitleText: text.title })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _GradientContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Zoom2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                subheaderText.map(function (i) {
	                  return _react2.default.createElement(
	                    'p',
	                    { key: uuidv4(), className: 'mpost-p inverted' },
	                    i
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _BasicContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Zoom2.default,
	              null,
	              _react2.default.createElement(_semanticUiReact.Header, { content: 'Services', className: 'mpost-header--huge', textAlign: 'center' }),
	              _react2.default.createElement('div', { className: 'mpost-header--divider' }),
	              _react2.default.createElement(
	                _semanticUiReact.Container,
	                { textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.List,
	                  { relaxed: true, divided: true, horizontal: true, size: 'huge' },
	                  services.map(function (service) {
	                    return _react2.default.createElement(
	                      _semanticUiReact.List.Item,
	                      { key: uuidv4() },
	                      _react2.default.createElement(
	                        _semanticUiReact.List.Content,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.List.Header,
	                          { as: 'h4', className: 'mpost-list--service' },
	                          service
	                        )
	                      )
	                    );
	                  })
	                ),
	                serviceText.map(function (i) {
	                  return _react2.default.createElement(
	                    'p',
	                    { key: uuidv4(), className: 'mpost-p' },
	                    i
	                  );
	                }),
	                _react2.default.createElement(_semanticUiReact.Button, { as: _gatsbyLink2.default, to: 'services/', content: 'Learn More', className: 'mpost-button' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _InvertedContainer2.default,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _Zoom2.default,
	              null,
	              _react2.default.createElement(_semanticUiReact.Header, { inverted: true, content: 'Featured Projects', className: 'mpost-header--huge inverted', textAlign: 'center' }),
	              _react2.default.createElement('div', { className: 'mpost-header--divider' }),
	              featuredText.map(function (i) {
	                return _react2.default.createElement(
	                  'p',
	                  { key: uuidv4(), className: 'mpost-p inverted' },
	                  i
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { style: { marginTop: 0, height: 0, backgroundColor: 'transparent', border: 0 }, clearing: true }),
	          _react2.default.createElement(_Works2.default, null),
	          _react2.default.createElement(_semanticUiReact.Divider, { style: { marginTop: 0, height: 1, backgroundColor: 'transparent', border: 0 }, clearing: true }),
	          _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: '#F2F2F2' } },
	            _react2.default.createElement(_Clients2.default, { testimony: true }),
	            _react2.default.createElement(_ContactSection2.default, null),
	            _react2.default.createElement(_Footer2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Responsive,
	          _semanticUiReact.Responsive.onlyMobile,
	          _react2.default.createElement(_HomeMobileHeader2.default, { menuOpen: this.openMenu }),
	          _react2.default.createElement(
	            _reactSlick2.default,
	            slideshow,
	            Object.keys(images).map(function (i) {
	              var text = shuffle(randomHeaderText)[0];
	              return _react2.default.createElement(
	                'div',
	                { key: uuidv4() },
	                _react2.default.createElement(HeaderSliderItem, { src: images[i], headerText: text.detail, headerTitleText: text.title })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _GradientContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Zoom2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                subheaderText.map(function (i) {
	                  return _react2.default.createElement(
	                    'p',
	                    { key: uuidv4(), className: 'mpost-p mobile inverted' },
	                    i
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _BasicContainer2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _Zoom2.default,
	                null,
	                _react2.default.createElement(_semanticUiReact.Header, { content: 'Services', className: 'mpost-header--huge mobile', textAlign: 'center' }),
	                _react2.default.createElement('div', { className: 'mpost-header--divider' })
	              ),
	              _react2.default.createElement(
	                _Zoom2.default,
	                null,
	                _react2.default.createElement(_semanticUiReact.List, { style: { textAlign: 'center', fontSize: '1.3rem' }, relaxed: 'very', items: services })
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              serviceText.map(function (i) {
	                return _react2.default.createElement(
	                  _Zoom2.default,
	                  { key: uuidv4() },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'mpost-p mobile' },
	                    i
	                  )
	                );
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Container,
	                { textAlign: 'center' },
	                _react2.default.createElement(_semanticUiReact.Button, { as: _gatsbyLink2.default, to: 'services/', content: 'Learn More', className: 'mpost-button' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _InvertedContainer2.default,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _Zoom2.default,
	              null,
	              _react2.default.createElement(_semanticUiReact.Header, { inverted: true, content: 'Featured Projects', className: 'mpost-header--huge inverted mobile', textAlign: 'center' }),
	              _react2.default.createElement('div', { className: 'mpost-header--divider' })
	            ),
	            featuredText.map(function (i) {
	              return _react2.default.createElement(
	                _Zoom2.default,
	                { key: uuidv4() },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'mpost-p mobile inverted' },
	                  i
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(_Works2.default, null),
	          _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: '#F2F2F2' } },
	            _react2.default.createElement(_Clients2.default, { testimony: true }),
	            _react2.default.createElement(_ContactSection2.default, null),
	            _react2.default.createElement(_Footer2.default, null)
	          )
	        )
	      )
	    );
	  };
	
	  return HomeContent;
	}(_react.Component);
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(HomeContent, null);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0b191845dad40f6b9ad4.js